import { useDefaultLayout } from 'react-resizable-panels';

const DETAILS_LAYOUT_STORAGE_ID = 'object-screen-details-layout';

export const useObjectDetailsPanelLayout = (objectType: string) => {
  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    id: `${DETAILS_LAYOUT_STORAGE_ID}:${objectType}`,
    onlySaveAfterUserInteractions: true,
  });

  return { defaultLayout, onLayoutChanged };
};
